module.exports = __webpack_public_path__ + "static/media/servico-falante.7ca16f70.svg";